import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { resultTreeMapTransformer } from '../../../../utils/tree'
import { PlatformContext } from '../../../../components/context/platform'

export const LabelChart: React.FunctionComponent = (props) => {
    const TOP = 20
    const platform = React.useContext(PlatformContext)

    return (
        <BPMChart {...props} title='Label' type='tree' subTitle={`By Sub Label (Top ${TOP})`}
            onRequestLoad={(options, signal) => {
                const result = BPMAnalyticsAPI.get<any>('downloads/label', options, signal)
                if (platform == 'create') {
                    return result
                }
                return resultTreeMapTransformer(result, 'label', 'sub_label').then((data) => {
                    data = data.map(d => {
                        d.items = d.items.sort((i2, i1) => i1.count - i2.count).slice(0, TOP)
                        return d
                    })
                    return data
                })
            }}
            customizeToolTip={(e: any, dataSource) => {
                let total = dataSource.items().reduce((p, item) => p + item.items.reduce((p, item) => p + item.count, 0), 0)
                return { text: `${e.node.data.count} for Downloads ${e.node.data[platform == 'create' ? 'label' : 'sub_label']} (${(100 / total * e.value).toFixed(1)}%)` }

            }}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: platform == 'create' ? 'label' : 'sub_label'
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/LabelChart.tsx